import axios from "axios";
import Qs from "qs";
import router from "../router";
import { Message } from "element-ui";
import store from "../store";

// export const baseURL = process.env.NODE_ENV == "development" ? "http://192.168.20.122:8080/" : "http://114.55.176.161:8080/"

// export const baseURL = "http://www.innopoms.com/"
// export const baseURL = "http://121.41.59.240:7777";
export const baseURL = "http://train-test.hooook.com/lz";
// export const baseURL = "https://jypx-server-api.hysz.co/"
// export const baseURL = "http://192.168.20.239:7777/";

axios.defaults.baseURL = baseURL;
axios.defaults.timeout = 30 * 1000;

//请求拦截
axios.interceptors.request.use(
  (config) => {
    const token = store.state.token;
    // console.log(token);
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    } else {
    }
    return config;
  },
  (error) => {
    return Promise.error(error);
  }
);

//响应拦截
axios.interceptors.response.use(
  (response) => {
    // console.log(response.data);
    //如果返回的状态码为200,说明接口请求成功，可以正常拿到数据
    if (response.data.status === 200 || response.data.code === 200) {
      return Promise.resolve(response);
    } else {
      if (response.data.code === 401) {
        // router.push("/login");
        window.location.reload();
        store.dispatch("resetLogin");
      } else {
        Message({
          message: response.data.msg,
          type: "error",
          duration: 5 * 1000,
        });
      }
      return Promise.reject(new Error(res.message || "Error"));
    }
  },
  (error) => {
    return Promise.reject(error.response);
  }
);

function get(url, params, headers = {}) {
  // console.log(headers, "头部信息");
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
        headers: headers.headers,
      })
      .then((res) => {
        resolve(res.data);
        // if (res.data.code == 414) {
        //   router.replace({
        //     path: '/login' // 到登录页重新获取token
        //   })
        // }else{
        //   resolve(res.data)
        // }
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

function post(url, params, headers = {}) {
  return new Promise((resolve, reject) => {
    // params.id = 1;
    // params = Qs.stringify(params)
    axios
      .post(url, params, {
        headers: headers.headers,
      })
      .then((res) => {
        // if (res.data.code == 414) {
        //   router.replace({
        //     path: '/login' // 到登录页重新获取token
        //   })
        // }else{
        //   resolve(res.data)
        // }

        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

function put(url, params, headers = {}) {
  return new Promise((resolve, reject) => {
    // console.log(headers, "post请求头部");
    axios
      .put(url, params, {
        headers: headers.headers,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

//非json格式的post请求
function postrest(url, params) {
  return new Promise((resolve, reject) => {
    // params.id = 1;
    params = Qs.stringify(params);
    axios
      .post(url, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

function del(url, params, headers = {}) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, params, {
        headers: headers.headers,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

export default {
  get,
  post,
  put,
  postrest,
  del,
};
